import { LogoutOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { clearAuthTokens } from "../../util/clearAuthTokens";

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthTokens(); // Clear the authentication tokens
    message.success("Logged out successfully!");
    navigate("/login"); // Redirect to the login page
  };

  return (
    <Button
      type="text"
      onClick={handleLogout}
      title="Logout"
      className="flex items-center justify-center w-10 h-10 bg-gray-200 hover:bg-gray-300 rounded-full transition-colors"
    >
      <LogoutOutlined className="text-gray-600 text-xl" />
    </Button>
  );
};

export default LogoutButton;
